import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'urql'
import { graphql } from 'app/generated/gql'
import { OPS_URL } from 'app/lib/opsUrqlClient'
import { type SmsAgentDeployment, toDeployment } from './smsAgentDeployment'

/** Deliberately separate from the configuration form's query: this is read-only deployment state
 *  that Atlas owns, and folding it into the editable form's record invites someone to submit it. */
const SMS_AGENT_DEPLOYMENT_QUERY = graphql(`
  query SmsAgentDeployment($locationId: ID!) {
    aiAgentConfiguration: opsAIAgentConfiguration(locationId: $locationId) {
      id
      systemPrompt
      promptVersion
      promptDeployedDate
      model
      temperature
      tools
    }
  }
`)

export function useSmsAgentDeployment(): {
  deployment?: SmsAgentDeployment
  fetching: boolean
  error: boolean
} {
  const { locationId } = useParams()
  const opsContext = useMemo(() => ({ url: OPS_URL }), [])

  const [{ data, fetching, error }] = useQuery({
    query: SMS_AGENT_DEPLOYMENT_QUERY,
    variables: { locationId: locationId! },
    pause: !locationId,
    context: opsContext,
  })

  const deployment = useMemo(() => toDeployment(data?.aiAgentConfiguration), [data])
  return { deployment, fetching, error: !!error }
}
